import { Text } from '@chakra-ui/react';
import { Helmet } from 'react-helmet';
import { CompleteIcon } from 'shared-components';
import SectionStartTemplate from '../../templates/sectionStart';
import { titleAppend } from '../../../utilities/head';
import { useDispatch } from 'react-redux';
import { logout } from '../../../store/auth/actions';
import { useSession } from 'shared-components/authentication';

const CourseConflictInfo = () => {
  const session = useSession();
  const dispatch = useDispatch();

  const onLogout = async () => {
    await session.onLogout(true);
    dispatch(logout());
  };

  const pageTitle = 'Thank you for confirming your personal information';

  return (
    <SectionStartTemplate pageHeader={pageTitle} hideProgress={true} onNext={onLogout} nextLabel="Log out">
      <Helmet>
        <title>
          {pageTitle} {titleAppend}
        </title>
      </Helmet>

      <CompleteIcon />

      <Text fontSize="lg">You will be notified by email when it's time to resume your CAS application.</Text>
    </SectionStartTemplate>
  );
};

export default CourseConflictInfo;
